export enum IconType {
  Activity = 'activity',
  Add = 'add',
  AI = 'ai',
  AirplaneInFlight = 'airplane-in-flight',
  AirplaneLanding = 'airplane-landing',
  AirplaneTakeoff = 'airplane-takeoff',
  AirplaneTilt = 'airplane-tilt',
  Airplane = 'airplane',
  Airplay = 'airplay',
  Alarm = 'alarm',
  AlignBottom = 'align-bottom',
  AlignCenterHorizontal = 'align-center-horizontal',
  AlignCenterVertical = 'align-center-vertical',
  AlignLeft = 'align-left',
  AlignRight = 'align-right',
  AlignTop = 'align-top',
  AnchorSimple = 'anchor-simple',
  Anchor = 'anchor',
  AndroidLogo = 'android-logo',
  Aperture = 'aperture',
  AppWindow = 'app-window',
  AppleLogo = 'apple-logo',
  ArchiveBox = 'archive-box',
  ArchiveTray = 'archive-tray',
  Archive = 'archive',
  Armchair = 'armchair',
  ArrowArcLeft = 'arrow-arc-left',
  ArrowArcRight = 'arrow-arc-right',
  ArrowBendDoubleUpLeft = 'arrow-bend-double-up-left',
  ArrowBendDoubleUpRight = 'arrow-bend-double-up-right',
  ArrowBendDownLeft = 'arrow-bend-down-left',
  ArrowBendDownRight = 'arrow-bend-down-right',
  ArrowBendLeftDown = 'arrow-bend-left-down',
  ArrowBendLeftUp = 'arrow-bend-left-up',
  ArrowBendRightDown = 'arrow-bend-right-down',
  ArrowBendRightUp = 'arrow-bend-right-up',
  ArrowBendUpLeft = 'arrow-bend-up-left',
  ArrowBendUpRight = 'arrow-bend-up-right',
  ArrowCircleDownLeft = 'arrow-circle-down-left',
  ArrowCircleDownRight = 'arrow-circle-down-right',
  ArrowCircleDown = 'arrow-circle-down',
  ArrowCircleLeft = 'arrow-circle-left',
  ArrowCircleRight = 'arrow-circle-right',
  ArrowCircleUp1 = 'arrow-circle-up-1',
  ArrowCircleUpLeft = 'arrow-circle-up-left',
  ArrowCircleUpRight = 'arrow-circle-up-right',
  ArrowCircleUp = 'arrow-circle-up',
  ArrowClockwise = 'arrow-clockwise',
  ArrowCounterClockwise = 'arrow-counter-clockwise',
  ArrowDownLeft = 'arrow-down-left',
  ArrowDownRight = 'arrow-down-right',
  ArrowElbowDownLeft = 'arrow-elbow-down-left',
  ArrowElbowDownRight = 'arrow-elbow-down-right',
  ArrowElbowLeftDown = 'arrow-elbow-left-down',
  ArrowElbowLeftUp = 'arrow-elbow-left-up',
  ArrowElbowLeft = 'arrow-elbow-left',
  ArrowElbowRightDown = 'arrow-elbow-right-down',
  ArrowElbowRightUp = 'arrow-elbow-right-up',
  ArrowElbowRight = 'arrow-elbow-right',
  ArrowElbowUpLeft = 'arrow-elbow-up-left',
  ArrowElbowUpRight = 'arrow-elbow-up-right',
  ArrowFatDown = 'arrow-fat-down',
  ArrowFatLeft = 'arrow-fat-left',
  ArrowFatLineDown = 'arrow-fat-line-down',
  ArrowFatLineLeft = 'arrow-fat-line-left',
  ArrowFatLineRight = 'arrow-fat-line-right',
  ArrowFatLineUp = 'arrow-fat-line-up',
  ArrowFatLinesDown = 'arrow-fat-lines-down',
  ArrowFatLinesLeft = 'arrow-fat-lines-left',
  ArrowFatLinesRight = 'arrow-fat-lines-right',
  ArrowFatLinesUp = 'arrow-fat-lines-up',
  ArrowFatRight = 'arrow-fat-right',
  ArrowFatUp = 'arrow-fat-up',
  ArrowLineDownLeft = 'arrow-line-down-left',
  ArrowLineDownRight = 'arrow-line-down-right',
  ArrowLineDown = 'arrow-line-down',
  ArrowLineLeft = 'arrow-line-left',
  ArrowLineRight = 'arrow-line-right',
  ArrowLineUpLeft = 'arrow-line-up-left',
  ArrowLineUpRight = 'arrow-line-up-right',
  ArrowLineUp = 'arrow-line-up',
  ArrowSquareDownLeft = 'arrow-square-down-left',
  ArrowSquareDownRight = 'arrow-square-down-right',
  ArrowSquareDown = 'arrow-square-down',
  ArrowSquareIn = 'arrow-square-in',
  ArrowSquareLeft = 'arrow-square-left',
  ArrowSquareOut = 'arrow-square-out',
  ArrowSquareRight = 'arrow-square-right',
  ArrowSquareUpLeft = 'arrow-square-up-left',
  ArrowSquareUpRight = 'arrow-square-up-right',
  ArrowSquareUp = 'arrow-square-up',
  ArrowUdownLeft = 'arrow-udown-left',
  ArrowUdownRight = 'arrow-udown-right',
  ArrowUleftDown = 'arrow-uleft-down',
  ArrowUleftUp = 'arrow-uleft-up',
  ArrowUpLeft = 'arrow-up-left',
  ArrowUpRight = 'arrow-up-right',
  ArrowUrightDown = 'arrow-uright-down',
  ArrowUrightUp = 'arrow-uright-up',
  ArrowUupLeft = 'arrow-uup-left',
  ArrowUupRight = 'arrow-uup-right',
  ArrowsClockwise = 'arrows-clockwise',
  ArrowsCounterClockwise = 'arrows-counter-clockwise',
  ArrowsDownUp = 'arrows-down-up',
  ArrowsInCardinal = 'arrows-in-cardinal',
  ArrowsInLineHorizontal = 'arrows-in-line-horizontal',
  ArrowsInLineVertical = 'arrows-in-line-vertical',
  ArrowsInSimple = 'arrows-in-simple',
  ArrowsIn = 'arrows-in',
  ArrowsLeftRight = 'arrows-left-right',
  ArrowsOutCardinal = 'arrows-out-cardinal',
  ArrowsOutLineHorizontal = 'arrows-out-line-horizontal',
  ArrowsOutLineVertical = 'arrows-out-line-vertical',
  ArrowsOutSimple = 'arrows-out-simple',
  ArrowsOut = 'arrows-out',
  ArticleMedium = 'article-medium',
  ArticleNyTimes = 'article-ny-times',
  Article = 'article',
  Asterisk = 'asterisk',
  At = 'at',
  Atom = 'atom',
  Backspace = 'backspace',
  BackSquare = 'back-square',
  BagSimple = 'bag-simple',
  Bag = 'bag',
  Bandaids = 'bandaids',
  Bank = 'bank',
  Barbell = 'barbell',
  Barcode = 'barcode',
  BatteryChargingVertical = 'battery-charging-vertical',
  BatteryCharging = 'battery-charging',
  BatteryEmpty = 'battery-empty',
  BatteryFull = 'battery-full',
  BatteryHigh = 'battery-high',
  BatteryLow = 'battery-low',
  BatteryMedium = 'battery-medium',
  BatteryWarningVertical = 'battery-warning-vertical',
  BatteryWarning = 'battery-warning',
  Bed = 'bed',
  BellRinging = 'bell-ringing',
  BellSimpleRinging = 'bell-simple-ringing',
  BellSimpleSlash = 'bell-simple-slash',
  BellSimpleZ = 'bell-simple-z',
  BellSimple = 'bell-simple',
  BellSlash = 'bell-slash',
  BellZ = 'bell-z',
  Bell = 'bell',
  Bicycle = 'bicycle',
  BluetoothConnected = 'bluetooth-connected',
  BluetoothSlash = 'bluetooth-slash',
  BluetoothX = 'bluetooth-x',
  Bluetooth = 'bluetooth',
  BookBookmark = 'book-bookmark',
  BookOpen = 'book-open',
  Book = 'book',
  BookmarkSimple = 'bookmark-simple',
  Bookmark = 'bookmark',
  BookmarksSimple = 'bookmarks-simple',
  Bookmarks = 'bookmarks',
  BriefcaseMetal = 'briefcase-metal',
  Broadcast = 'broadcast',
  Browser = 'browser',
  Browsers = 'browsers',
  BugBeetle = 'bug-beetle',
  BugDroid = 'bug-droid',
  Bug = 'bug',
  Buildings = 'buildings',
  Bus = 'bus',
  Calculator = 'calculator',
  CalendarBlank = 'calendar-blank',
  CalendarX = 'calendar-x',
  CameraSlash = 'camera-slash',
  Camera = 'camera',
  CarSimple = 'car-simple',
  Car = 'car',
  Cardholder = 'cardholder',
  Cards = 'cards',
  CaretCircleDoubleDown = 'caret-circle-double-down',
  CaretCircleDoubleLeft = 'caret-circle-double-left',
  CaretCircleDoubleRight = 'caret-circle-double-right',
  CaretCircleDoubleUp = 'caret-circle-double-up',
  CaretCircleDown = 'caret-circle-down',
  CaretCircleLeft = 'caret-circle-left',
  CaretCircleRight = 'caret-circle-right',
  CaretCircleUp = 'caret-circle-up',
  CaretDoubleDown = 'caret-double-down',
  CaretDoubleLeft = 'caret-double-left',
  CaretDoubleRight = 'caret-double-right',
  CaretDoubleUp = 'caret-double-up',
  CaretDown = 'caret-down',
  CaretLeft = 'caret-left',
  CaretRight = 'caret-right',
  CaretUp = 'caret-up',
  CellSignalFull = 'cell-signal-full',
  CellSignalHigh = 'cell-signal-high',
  CellSignalLow = 'cell-signal-low',
  CellSignalMedium = 'cell-signal-medium',
  CellSignalNone = 'cell-signal-none',
  CellSignalSlash = 'cell-signal-slash',
  CellSignalX = 'cell-signal-x',
  ChalkboardSimple = 'chalkboard-simple',
  ChalkboardTeacher = 'chalkboard-teacher',
  Chalkboard = 'chalkboard',
  ChartBarHorizontal = 'chart-bar-horizontal',
  ChartBar = 'chart-bar',
  ChartLineUp = 'chart-line-up',
  ChartLine = 'chart-line',
  ChartPieSlice = 'chart-pie-slice',
  ChartPie = 'chart-pie',
  ChatCenteredDots = 'chat-centered-dots',
  ChatCenteredText = 'chat-centered-text',
  ChatCentered = 'chat-centered',
  ChatCircleDots = 'chat-circle-dots',
  ChatCircleText = 'chat-circle-text',
  ChatCircle = 'chat-circle',
  ChatDots = 'chat-dots',
  ChatTeardropDots = 'chat-teardrop-dots',
  ChatTeardropText = 'chat-teardrop-text',
  ChatTeardrop = 'chat-teardrop',
  ChatText = 'chat-text',
  Chat = 'chat',
  ChatsCircle = 'chats-circle',
  ChatsTeardrop = 'chats-teardrop',
  Chats = 'chats',
  CheckSquareOffset = 'check-square-offset',
  CheckSquare = 'check-square',
  Checks = 'checks',
  CircleDashed = 'circle-dashed',
  CircleHalfTilt = 'circle-half-tilt',
  CircleWavyCheck = 'circle-wavy-check',
  CircleWavyQuestion = 'circle-wavy-question',
  CircleWavyWarning = 'circle-wavy-warning',
  CircleWavy = 'circle-wavy',
  CirclesFour = 'circles-four',
  CirclesThreePlus = 'circles-three-plus',
  CirclesThree = 'circles-three',
  ClipboardText = 'clipboard-text',
  Clipboard = 'clipboard',
  ClockAfternoon = 'clock-afternoon',
  ClockClockwise = 'clock-clockwise',
  ClockCounterClockwise = 'clock-counter-clockwise',
  ClosedCaptioning = 'closed-captioning',
  CloudArrowDown = 'cloud-arrow-down',
  CloudArrowUp = 'cloud-arrow-up',
  CloudCheck = 'cloud-check',
  CloudFog = 'cloud-fog',
  CloudLightning = 'cloud-lightning',
  CloudMoon = 'cloud-moon',
  CloudRain = 'cloud-rain',
  CloudSlash = 'cloud-slash',
  CloudSnow = 'cloud-snow',
  CloudSun = 'cloud-sun',
  Cloud = 'cloud',
  Club = 'club',
  CodeSimple = 'code-simple',
  Code = 'code',
  Coffee = 'coffee',
  Coin = 'coin',
  Columns = 'columns',
  Command = 'command',
  Compass = 'compass',
  ComputerTower = 'computer-tower',
  CopySimple = 'copy-simple',
  Copy = 'copy',
  Copyright = 'copyright',
  CornersIn = 'corners-in',
  CornersOut = 'corners-out',
  Cpu = 'cpu',
  CreditCard = 'credit-card',
  Crop = 'crop',
  CrosshairSimple = 'crosshair-simple',
  Crosshair = 'crosshair',
  CrownSimple = 'crown-simple',
  Crown = 'crown',
  Cube = 'cube',
  CurrencyBtc = 'currency-btc',
  CurrencyCircleDollar = 'currency-circle-dollar',
  CurrencyCny = 'currency-cny',
  CurrencyDollarSimple = 'currency-dollar-simple',
  CurrencyDollar = 'currency-dollar',
  CurrencyEur = 'currency-eur',
  CurrencyGbp = 'currency-gbp',
  CurrencyInr = 'currency-inr',
  CurrencyJpy = 'currency-jpy',
  CurrencyKrw = 'currency-krw',
  CurrencyRub = 'currency-rub',
  Cursor = 'cursor',
  Database = 'database',
  DesktopTower = 'desktop-tower',
  Desktop = 'desktop',
  DeviceMobileCamera = 'device-mobile-camera',
  DeviceMobileSpeaker = 'device-mobile-speaker',
  DeviceMobile = 'device-mobile',
  DeviceTabletCamera = 'device-tablet-camera',
  DeviceTabletSpeaker = 'device-tablet-speaker',
  DeviceTablet = 'device-tablet',
  Diamond = 'diamond',
  DiceFive = 'dice-five',
  DiceFour = 'dice-four',
  DiceOne = 'dice-one',
  DiceSix = 'dice-six',
  DiceThree = 'dice-three',
  DiceTwo = 'dice-two',
  Disc = 'disc',
  DiscordLogo = 'discord-logo',
  Divide = 'divide',
  Document = 'document',
  DocumentDownload = 'document-download',
  DocumentText = 'document-text',
  DocumentCopy = 'document-copy',
  Door = 'door',
  DotsNine = 'dots-nine',
  DotsSixVertical = 'dots-six-vertical',
  DotsThreeCircleVertical = 'dots-three-circle-vertical',
  DotsThreeCircle = 'dots-three-circle',
  DotsThreeOutlineVertical = 'dots-three-outline-vertical',
  DotsThreeOutline = 'dots-three-outline',
  DotsThreeVertical = 'dots-three-vertical',
  DotsThree = 'dots-three',
  DownloadSimple = 'download-simple',
  Download = 'download',
  DribbbleLogo = 'dribbble-logo',
  DropHalf = 'drop-half',
  Drop = 'drop',
  Eject = 'eject',
  EnvelopeOpen = 'envelope-open',
  EnvelopeSimpleOpen = 'envelope-simple-open',
  EnvelopeSimple = 'envelope-simple',
  Envelope = 'envelope',
  Equals = 'equals',
  Eraser = 'eraser',
  EyeClosed = 'eye-closed',
  EyeSlash = 'eye-slash',
  Eyedropper = 'eyedropper',
  FaceMask = 'face-mask',
  FacebookLogo = 'facebook-logo',
  FadersHorizontal = 'faders-horizontal',
  Faders = 'faders',
  FastForwardCircle = 'fast-forward-circle',
  FigmaLogo = 'figma-logo',
  FileArrowDown = 'file-arrow-down',
  FileArrowUp = 'file-arrow-up',
  FileMinus = 'file-minus',
  FilePlus = 'file-plus',
  FileSearch = 'file-search',
  FileText = 'file-text',
  FileX = 'file-x',
  File = 'file',
  FingerprintSimple = 'fingerprint-simple',
  Fingerprint = 'fingerprint',
  FinnTheHuman = 'finn-the-human',
  FireSimple = 'fire-simple',
  Fire = 'fire',
  FirstAidKit = 'first-aid-kit',
  FirstAid = 'first-aid',
  FlagBanner = 'flag-banner',
  Flame = 'flame',
  Flashlight = 'flashlight',
  FolderMinus = 'folder-minus',
  FolderNotchMinus = 'folder-notch-minus',
  FolderNotchOpen = 'folder-notch-open',
  FolderNotchPlus = 'folder-notch-plus',
  FolderNotch = 'folder-notch',
  FolderOpen = 'folder-open',
  FolderPlus = 'folder-plus',
  FolderSimpleMinus = 'folder-simple-minus',
  FolderSimplePlus = 'folder-simple-plus',
  FolderSimple = 'folder-simple',
  Folder = 'folder',
  Folders = 'folders',
  ForkKnife = 'fork-knife',
  FrameCorners = 'frame-corners',
  FramerLogo = 'framer-logo',
  Funnel = 'funnel',
  FunnelSimple = 'funnel-simple',
  FunnelVertical = 'funnel-vertical',
  Gallery = 'gallery',
  GameController = 'game-controller',
  Gauge = 'gauge',
  GearSix = 'gear-six',
  Gear = 'gear',
  Ghost = 'ghost',
  Gif = 'gif',
  Gift = 'gift',
  GitBranch = 'git-branch',
  GitCommit = 'git-commit',
  GitDiff = 'git-diff',
  GitFork = 'git-fork',
  GitMerge = 'git-merge',
  GitPullRequest = 'git-pull-request',
  GithubLogo = 'github-logo',
  GlobeHemisphereEast = 'globe-hemisphere-east',
  GlobeHemisphereWest = 'globe-hemisphere-west',
  GlobeSimple = 'globe-simple',
  GlobeStand = 'globe-stand',
  Globe = 'globe',
  GoogleLogo = 'google-logo',
  GooglePlayLogo = 'google-play-logo',
  GraduationCap = 'graduation-cap',
  GridFour = 'grid-four',
  HandFist = 'hand-fist',
  HandGrabbing = 'hand-grabbing',
  HandPalm = 'hand-palm',
  HandPointing = 'hand-pointing',
  HandSoap = 'hand-soap',
  HandWaving = 'hand-waving',
  Hand = 'hand',
  HandbagSimple = 'handbag-simple',
  Handbag = 'handbag',
  Handshake = 'handshake',
  HardDrive = 'hard-drive',
  HardDrives = 'hard-drives',
  HashStraight = 'hash-straight',
  Hash = 'hash',
  Headphones = 'headphones',
  Headset = 'headset',
  HeartStraight = 'heart-straight',
  Heart = 'heart',
  Heartbeat = 'heartbeat',
  Hexagon = 'hexagon',
  HighlighterCircle = 'highlighter-circle',
  Horse = 'horse',
  HourglassHigh = 'hourglass-high',
  HourglassLow = 'hourglass-low',
  HourglassMedium = 'hourglass-medium',
  HourglassSimpleHigh = 'hourglass-simple-high',
  HourglassSimpleLow = 'hourglass-simple-low',
  HourglassSimpleMedium = 'hourglass-simple-medium',
  HourglassSimple = 'hourglass-simple',
  Hourglass = 'hourglass',
  HouseLine = 'house-line',
  HouseSimple = 'house-simple',
  House = 'house',
  Support24 = '24-support',
  ArrowDown = 'arrow-down',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowUpDown = 'arrow-up-down',
  ArrowUp = 'arrow-up',
  Briefcase = 'briefcase',
  Building = 'building',
  CalendarFill = 'calendar-fill',
  Calendar = 'calendar',
  CheckCircle = 'check-circle',
  Check = 'check',
  CheckboxChecked = 'checkbox-checked',
  CheckboxEmpty = 'checkbox-empty',
  ChevronDown = 'chevron-down',
  ChevronUp = 'chevron-up',
  CircleHalf = 'circle-half',
  CircleLeft = 'circle-left',
  CircleRight = 'circle-right',
  Circle = 'circle',
  CircleFilled = 'circle-filled',
  Clock = 'clock',
  Close = 'close',
  DollarCircle = 'dollar-circle',
  ExternalLink = 'external-link',
  EyeOff = 'eye-off',
  Eye = 'eye',
  FaceSad = 'face-sad',
  Flag = 'flag',
  FloppyDisk = 'floppy-disk',
  Food = 'food',
  Location = 'location',
  LogoFull = 'logo-full',
  LogoSmall = 'logo-small',
  Magicpen = 'magicpen',
  Mail = 'mail',
  Megaphone = 'megaphone',
  Plus = 'plus',
  Save = 'save',
  SearchNormal = 'search-normal',
  Search = 'search',
  Security = 'security',
  Sports = 'sports',
  Trash = 'trash',
  TrashAlt = 'trash-alt',
  UserOctagon = 'user-octagon',
  User = 'user',
  IdentificationCard = 'identification-card',
  ImageSquare = 'image-square',
  Image = 'image',
  Infinity = 'infinity',
  Info = 'info',
  InstagramLogo = 'instagram-logo',
  Intersect = 'intersect',
  Jeep = 'jeep',
  Key = 'key',
  Keyboard = 'keyboard',
  Knife = 'knife',
  Lamp = 'lamp',
  Laptop = 'laptop',
  Leaf = 'leaf',
  Lifebuoy = 'lifebuoy',
  Lightbulb = 'lightbulb',
  LightningSlash = 'lightning-slash',
  Lightning = 'lightning',
  LinkBreak = 'link-break',
  LinkSimpleBreak = 'link-simple-break',
  LinkSimpleHorizontalBreak = 'link-simple-horizontal-break',
  LinkSimpleHorizontal = 'link-simple-horizontal',
  LinkSimple = 'link-simple',
  Link = 'link',
  LinkedinLogo = 'linkedin-logo',
  ListBullets = 'list-bullets',
  ListDashes = 'list-dashes',
  ListNumbers = 'list-numbers',
  ListPlus = 'list-plus',
  List = 'list',
  LockKeyOpen = 'lock-key-open',
  LockKey = 'lock-key',
  LockLaminatedOpen = 'lock-laminated-open',
  LockLaminated = 'lock-laminated',
  LockOpen = 'lock-open',
  LockSimpleOpen = 'lock-simple-open',
  LockSimple = 'lock-simple',
  Lock = 'lock',
  Logout = 'logout',
  MagnetStraight = 'magnet-straight',
  Magnet = 'magnet',
  MagnifyingGlassMinus = 'magnifying-glass-minus',
  MagnifyingGlassPlus = 'magnifying-glass-plus',
  MagnifyingGlass = 'magnifying-glass',
  MapPinLine = 'map-pin-line',
  MapPin = 'map-pin',
  MapTrifold = 'map-trifold',
  MarkerCircle = 'marker-circle',
  Martini = 'martini',
  MathOperations = 'math-operations',
  Medal = 'medal',
  MediumLogo = 'medium-logo',
  MegaphoneSimple = 'megaphone-simple',
  Message = 'message',
  MicrophoneSlash = 'microphone-slash',
  Microphone = 'microphone',
  MinusCircle = 'minus-circle',
  Minus = 'minus',
  Money = 'money',
  MonitorPlay = 'monitor-play',
  Monitor = 'monitor',
  MoonStars = 'moon-stars',
  Moon = 'moon',
  MouseSimple = 'mouse-simple',
  Mouse = 'mouse',
  MusicNoteSimple = 'music-note-simple',
  MusicNote = 'music-note',
  LinearSms = 'linear-sms',
  MusicNotesSimple = 'music-notes-simple',
  MusicNotes = 'music-notes',
  NavigationArrow = 'navigation-arrow',
  NewspaperClipping = 'newspaper-clipping',
  Newspaper = 'newspaper',
  NoteBlank = 'note-blank',
  NotePencil = 'note-pencil',
  Note = 'note',
  Notebook = 'notebook',
  Notepad = 'notepad',
  NumberCircleEight = 'number-circle-eight',
  NumberCircleFive = 'number-circle-five',
  NumberCircleFour = 'number-circle-four',
  NumberCircleNine = 'number-circle-nine',
  NumberCircleOne = 'number-circle-one',
  NumberCircleSeven = 'number-circle-seven',
  NumberCircleSix = 'number-circle-six',
  NumberCircleThree = 'number-circle-three',
  NumberCircleTwo = 'number-circle-two',
  NumberCircleZero = 'number-circle-zero',
  NumberEight = 'number-eight',
  NumberFive = 'number-five',
  NumberFour = 'number-four',
  NumberNine = 'number-nine',
  NumberOne = 'number-one',
  NumberSeven = 'number-seven',
  NumberSix = 'number-six',
  NumberSquareEight = 'number-square-eight',
  NumberSquareFive = 'number-square-five',
  NumberSquareFour = 'number-square-four',
  NumberSquareNine = 'number-square-nine',
  NumberSquareOne = 'number-square-one',
  NumberSquareSeven = 'number-square-seven',
  NumberSquareSix = 'number-square-six',
  NumberSquareThree = 'number-square-three',
  NumberSquareTwo = 'number-square-two',
  NumberSquareZero = 'number-square-zero',
  NumberThree = 'number-three',
  NumberTwo = 'number-two',
  NumberZero = 'number-zero',
  NyTimesLogo = 'ny-times-logo',
  Octagon = 'octagon',
  Package = 'package',
  PaintBrushBroad = 'paint-brush-broad',
  PaintBucket = 'paint-bucket',
  PaperPlaneRight = 'paper-plane-right',
  PaperPlaneTilt = 'paper-plane-tilt',
  PaperPlane = 'paper-plane',
  PaperclipHorizontal = 'paperclip-horizontal',
  Paperclip = 'paperclip',
  Path = 'path',
  PauseCircle = 'pause-circle',
  Pause = 'pause',
  PawPrint = 'paw-print',
  Peace = 'peace',
  Pedestrian = 'pedestrian',
  PenNibStraight = 'pen-nib-straight',
  PenNib = 'pen-nib',
  Pen = 'pen',
  PencilCircle = 'pencil-circle',
  PencilLine = 'pencil-line',
  PencilSimple = 'pencil-simple',
  Pencil = 'pencil',
  Percent = 'percent',
  PhoneCall = 'phone-call',
  PhoneDisconnect = 'phone-disconnect',
  PhoneIncoming = 'phone-incoming',
  PhoneOutgoing = 'phone-outgoing',
  PhoneSlash = 'phone-slash',
  PhoneX = 'phone-x',
  Phone = 'phone',
  PhosphorLogo = 'phosphor-logo',
  PictureInPicture = 'picture-in-picture',
  PinterestLogo = 'pinterest-logo',
  Placeholder = 'placeholder',
  Planet = 'planet',
  PlayCircle = 'play-circle',
  Play = 'play',
  PlusCircle = 'plus-circle',
  PlusMinus = 'plus-minus',
  PokerChip = 'poker-chip',
  Power = 'power',
  PresentationChart = 'presentation-chart',
  Presentation = 'presentation',
  Printer = 'printer',
  ProhibitInset = 'prohibit-inset',
  Prohibit = 'prohibit',
  ProjectorScreenChart = 'projector-screen-chart',
  ProjectorScreen = 'projector-screen',
  PushPinSimpleSlash = 'push-pin-simple-slash',
  PushPinSimple = 'push-pin-simple',
  PushPinSlash = 'push-pin-slash',
  PushPin = 'push-pin',
  PuzzlePiece = 'puzzle-piece',
  Question = 'question',
  Quotes = 'quotes',
  Radical = 'radical',
  RainbowCloud = 'rainbow-cloud',
  Rainbow = 'rainbow',
  Receipt = 'receipt',
  Record = 'record',
  RecoveryConvert = 'recovery-convert',
  Rectangle = 'rectangle',
  RedditLogo = 'reddit-logo',
  RepeatOnce = 'repeat-once',
  Repeat = 'repeat',
  RewindCircle = 'rewind-circle',
  RocketLaunch = 'rocket-launch',
  Rocket = 'rocket',
  Rows = 'rows',
  RssSimple = 'rss-simple',
  Rss = 'rss',
  Scissors = 'scissors',
  Screencast = 'screencast',
  ScribbleLoop = 'scribble-loop',
  ShareNetwork = 'share-network',
  Share = 'share',
  ShareFat = 'share-fat',
  ShieldCheck = 'shield-check',
  ShieldChevron = 'shield-chevron',
  ShieldSlash = 'shield-slash',
  ShieldWarning = 'shield-warning',
  Shield = 'shield',
  ShoppingBagOpen = 'shopping-bag-open',
  ShoppingBag = 'shopping-bag',
  ShoppingCartSimple = 'shopping-cart-simple',
  ShoppingCart = 'shopping-cart',
  ShuffleAngular = 'shuffle-angular',
  ShuffleSimple = 'shuffle-simple',
  Shuffle = 'shuffle',
  SignIn = 'sign-in',
  SignOut = 'sign-out',
  SimCard = 'sim-card',
  SketchLogo = 'sketch-logo',
  SkipBackCircle = 'skip-back-circle',
  SkipBack = 'skip-back',
  SkipForwardCircle = 'skip-forward-circle',
  SkipForward = 'skip-forward',
  SlackLogo = 'slack-logo',
  SlidersHorizontal = 'sliders-horizontal',
  Sliders = 'sliders',
  SmileyBlank = 'smiley-blank',
  SmileyMeh = 'smiley-meh',
  SmileyNervous = 'smiley-nervous',
  SmileySad = 'smiley-sad',
  SmileySticker = 'smiley-sticker',
  SmileyWink = 'smiley-wink',
  SmileyXeyes = 'smiley-xeyes',
  Smiley = 'smiley',
  SnapchatLogo = 'snapchat-logo',
  Snowflake = 'snowflake',
  SortAscending = 'sort-ascending',
  SortDescending = 'sort-descending',
  Spade = 'spade',
  SpeakerHigh = 'speaker-high',
  SpeakerLow = 'speaker-low',
  SpeakerNone = 'speaker-none',
  SpeakerSimpleHigh = 'speaker-simple-high',
  SpeakerSimpleLow = 'speaker-simple-low',
  SpeakerSimpleNone = 'speaker-simple-none',
  SpeakerSimpleSlash = 'speaker-simple-slash',
  SpeakerSimpleX = 'speaker-simple-x',
  SpeakerSlash = 'speaker-slash',
  SpeakerX = 'speaker-x',
  SpinnerGap = 'spinner-gap',
  Spinner = 'spinner',
  SpotifyLogo = 'spotify-logo',
  SquareHalf = 'square-half',
  Square = 'square',
  SquaresFour = 'squares-four',
  StackSimple = 'stack-simple',
  Star = 'star',
  StarFilled = 'star-filled',
  Sticker = 'sticker',
  StopCircle = 'stop-circle',
  Stop = 'stop',
  Storefront = 'storefront',
  SuitcaseSimple = 'suitcase-simple',
  Suitcase = 'suitcase',
  SunDim = 'sun-dim',
  SunHorizon = 'sun-horizon',
  Sun = 'sun',
  Sword = 'sword',
  Table = 'table',
  TagChevron = 'tag-chevron',
  TagSimple = 'tag-simple',
  Tag = 'tag',
  Target = 'target',
  TelegramLogo = 'telegram-logo',
  Terminal = 'terminal',
  TextAlignCenter = 'text-align-center',
  TextAlignJustify = 'text-align-justify',
  TextAlignLeft = 'text-align-left',
  TextAlignRight = 'text-align-right',
  TextBolder = 'text-bolder',
  TextItalic = 'text-italic',
  TextStrikethrough = 'text-strikethrough',
  TextT = 'text-t',
  TextUnderline = 'text-underline',
  ThermometerCold = 'thermometer-cold',
  ThermometerHot = 'thermometer-hot',
  ThermometerSimple = 'thermometer-simple',
  Thermometer = 'thermometer',
  ThumbsDown = 'thumbs-down',
  ThumbsUp = 'thumbs-up',
  Ticket = 'ticket',
  Timer = 'timer',
  ToggleLeft = 'toggle-left',
  ToggleRight = 'toggle-right',
  ToteSimple = 'tote-simple',
  Tote = 'tote',
  TrafficSign = 'traffic-sign',
  TrainRegional = 'train-regional',
  TrainSimple = 'train-simple',
  Train = 'train',
  Translate = 'translate',
  TrashSimple = 'trash-simple',
  Tray = 'tray',
  TreeStructure = 'tree-structure',
  Trello = 'trello',
  TrendDown = 'trend-down',
  TrendUp = 'trend-up',
  Triangle = 'triangle',
  Trophy = 'trophy',
  Truck = 'truck',
  Tshirt = 'tshirt',
  TwitchLogo = 'twitch-logo',
  TwitterLogo = 'twitter-logo',
  UmbrellaSimple = 'umbrella-simple',
  Umbrella = 'umbrella',
  UploadSimple = 'upload-simple',
  Upload = 'upload',
  UserCircleGear = 'user-circle-gear',
  UserCircleMinus = 'user-circle-minus',
  UserCirclePlus = 'user-circle-plus',
  UserCircle = 'user-circle',
  UserGear = 'user-gear',
  UserMinus = 'user-minus',
  UserPlus = 'user-plus',
  UserAdd = 'user-add',
  UserRectangle = 'user-rectangle',
  UserSquare = 'user-square',
  Users = 'users',
  Vibrate = 'vibrate',
  VideoCameraSlash = 'video-camera-slash',
  VideoCamera = 'video-camera',
  Voicemail = 'voicemail',
  Wall = 'wall',
  Wallet = 'wallet',
  WarningCircle = 'warning-circle',
  WarningOctagon = 'warning-octagon',
  Warning = 'warning',
  Watch = 'watch',
  WhatsappLogo = 'whatsapp-logo',
  Wheelchair = 'wheelchair',
  WifiHigh = 'wifi-high',
  WifiLow = 'wifi-low',
  WifiMedium = 'wifi-medium',
  WifiNone = 'wifi-none',
  WifiSlash = 'wifi-slash',
  WifiX = 'wifi-x',
  Wind = 'wind',
  Wrench = 'wrench',
  X = 'x',
  Xcircle = 'xcircle',
  Xsquare = 'xsquare',
  YoutubeLogo = 'youtube-logo',
  YoutubeLogoFilled = 'youtube-logo-filled',
}
